import { BACKEND_API } from 'global/environment'
import { getRequest$ } from 'utils/http'

const BASE_URL = `${BACKEND_API}/settings`

export const getSettings$ = () => getRequest$(BASE_URL)
